import {useMutation} from '@apollo/react-hooks';
import gql from 'graphql-tag';
import {gqlStatusMessage, StatusMessage} from '../../graphql/common.datatypes';

export interface SendEmailToGroupInput {
    data: {
        tour_id?: number
        group_id?: number
        billing_party_id?: number
        email: string
        subject: string
        message: string
        softCancelledConfirmation: boolean
        recipients: number[]
    };
}

interface SendEmailToGroupData {
    sendEmailToGroup: StatusMessage
}

export const SEND_EMAIL_MUTATION = gql`
    mutation sendEmailToGroup($data: SendEmailToGroupInput!) {
        sendEmailToGroup(data: $data) {
            ${gqlStatusMessage}
        }
    }
`;

export const sendEmailToGroup = () => useMutation<SendEmailToGroupData, SendEmailToGroupInput>(
    SEND_EMAIL_MUTATION,
);

export default sendEmailToGroup;
